module.exports = __webpack_public_path__ + "img/italic.e5127cb7.svg";